export enum RelationAction {
  Show = 'SHOW',
  Hide = 'HIDE',
  Disable = 'DISABLE',
  Enable = 'ENABLE',
}
